import { createFileRoute } from "@tanstack/react-router";

import { AdminShell } from "@/components/admin/AdminShell";
import { KycReviewDetail } from "@/components/admin/KycReviewDetail";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/kyc_/$id")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: KycFileRoute,
});

function KycFileRoute() {
  const { id } = Route.useParams();
  return (
    <AdminShell page="kyc">
      <KycReviewDetail id={id} />
    </AdminShell>
  );
}
